import {IVirtualizedTableColumn} from "../../components/Table/VirtualizedTableInterfaces";
import {EVirtualizedTableCellType} from "../../components/Table/VirtualizedTableEnums";

/** Column keys for all columns to be displayed for modeltype. */
export const BtypKey = "btyp";
export const NameKey = "name";
export const TypeFamilyKey = "typefamily";
export const IntSeqKey = "intSequence";
export const ColorKey = "color";
export const ChangedByKey = "changedBy";
export const ChangedTimestampKey = "changedTimestamp";
export const Visible = "visible";
export const GenerationKey = "generation";

/** All possible columns supported for option basic. */
export const ModelTypeColumnKeys = [
    BtypKey,
    NameKey,
    GenerationKey,
    TypeFamilyKey,
    IntSeqKey,
    ColorKey,
    ChangedByKey,
    ChangedTimestampKey,
    Visible
];

export function sortModeltypeColumns(a: IVirtualizedTableColumn, b: IVirtualizedTableColumn): number {
    return ModelTypeColumnKeys.indexOf(a.key) - ModelTypeColumnKeys.indexOf(b.key);
}

export const getColumns = (t: reactI18Next.TranslationFunction, readonly: boolean,isAdmin:boolean): IVirtualizedTableColumn[] => ([
        {
            key: "btyp",
            label: t("MT_BASIC_VIEW:MODELTYPE"),
            rowType: EVirtualizedTableCellType.TEXTINPUT,
            options: {readOnly: readonly, cellWidth: 300},
        },
        {
            key: "name",
            label: t("MT_BASIC_VIEW:NAME"),
            rowType: EVirtualizedTableCellType.TWOLANGUAGEINPUT,
            options: {readOnly: readonly, cellWidth: 300},
        },
        {
            key: "generation",
            label: t("MT_BASIC_VIEW:GENERATION"),
            rowType: EVirtualizedTableCellType.GENERATION,
            options: {readOnly: readonly, cellWidth: 300},
        },
        {
            key: "typefamily",
            label: t("MT_BASIC_VIEW:TYPEFAMILY"),
            rowType: EVirtualizedTableCellType.DROPDOWN,
            options: {readOnly: readonly, cellWidth: 300},
        },
        {
            key: "intSequence",
            label: t("MT_BASIC_VIEW:INT_SEQUENCE"),
            rowType: EVirtualizedTableCellType.NUMBERINPUT,
            options: {readOnly: readonly, cellWidth: 240},
        },
        {
            key: "color",
            label: t("MT_BASIC_VIEW:COLOR"),
            rowType: EVirtualizedTableCellType.COLORDROPDOWN,
            options: {readOnly: readonly, cellWidth: 320},
        },
        {
            key: ChangedByKey,
            label: t("MT_BASIC_VIEW:CHANGED_BY"),
            rowType: EVirtualizedTableCellType.TEXTINPUT,
            options: {readOnly: true, cellWidth: 200},
        },
        {
            key: ChangedTimestampKey,
            label: t("MT_BASIC_VIEW:CHANGED_TIMESTAMP"),
            rowType: EVirtualizedTableCellType.TEXTINPUT,
            options: {readOnly: true, cellWidth: 200},
        },
        {
            key: Visible,
            label: t("MT_BASIC_VIEW:SHOW_HIDE"),
            rowType: EVirtualizedTableCellType.CHECKBOX,
            options: {readOnly: readonly || !isAdmin, cellWidth: 120},
        }
    ]);



// WEBPACK FOOTER //
// ./src/views/ModeltypeBasicView/ModeltypeBasicColumns.ts